import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../util/authConfig";
import { Button, FormControlLabel, Checkbox, Box, Link } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { BorderColor } from "@material-ui/icons";
import { spacing } from '@material-ui/system';


/**
 * Renders a button which, when selected, will open a popup for login
 */
const LoginButton = (props : any) => {
    const {inProgress, instance } = useMsal();
    const history = useHistory();
    const [checked, setChecked] = React.useState(false);
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const isAuthenticated = useIsAuthenticated();
    console.log("authenticated = " + isAuthenticated);
    const handleLogin = (instance) => {
        if (checked) {
            if (isAuthenticated) {
                if (props.redirect === undefined ) {
                    history.push("/dashboard");
                }
                else {
                    console.log("redirect path: " + props.redirect);
                    history.push(props.redirect);
                }
                
            }
            else {
                instance.loginRedirect(loginRequest)
                    .then(() => {

                        if (props.redirect === undefined) {
                            history.push("/dashboard");
                        }
                        else {
                            console.log("redirect path: " + props.redirect);
                            history.push(props.redirect);
                        }
                     
                    })
                    .catch(e => {
                        console.error("dev caught error");
                        console.error(e);
                    });

            }
        }
    }
    return (
        <div style={{ color: 'white' }}>
            <div style={{ textAlign: 'center' }}>
                <Button variant="contained" onClick={() => handleLogin(instance)}>Sign in</Button>
            </div>
            <br />
            <div style={{ textAlign: 'center' }}>
                <FormControlLabel
                    control={<Checkbox checked={checked} onChange={handleChange} style={{
                        color: "#ffffff",
                    }} />}
                    label={
                        <div>By checking and logging in, user accepts Terms of Use.  <Link href='https://hnihealthcare.com/vitalsmd-terms.pdf' target="_blank" rel="noopener" color="primary" >Read Terms</Link></div>
                    }
                />
            </div>

        </div>
    );
}

export default LoginButton